<div
  class="articles-step__ddt-info"
  [class.missing]="!orderService.ddtDate.value"
>
  <i
    class="bx"
    [ngClass]="
      orderService.ddtDate.value ? 'bx-check-circle' : 'bx-error-circle'
    "
  ></i>

  @if (orderService.ddtDate.value) {
    <span class="color-blue">
      DDT caricato il
      <strong>
        {{ orderService.ddtDate.value | date: "dd/MM/yy" }} alle
        {{ orderService.ddtDate.value | date: "HH:mm" }}
      </strong>
    </span>
  } @else {
    <span>DDT non è stato caricato</span>
  }
</div>

<h2 class="articles-step__title">Elenco codici articoli</h2>
<div class="articles-step__divider"></div>

@if (products.length) {
  <div class="articles-step__list">
    <div class="articles-step__row articles-step__header">
      <div class="articles-step__cell articles-step__cell--code">Codice</div>
      <div class="articles-step__cell articles-step__cell--name">Prodotto</div>
      <div class="articles-step__cell articles-step__cell--qty">Quantità</div>
      <div class="articles-step__cell articles-step__cell--action">Azione</div>
    </div>

    @for (article of products; track article.supplier_certificate_product_id) {
      <div
        class="articles-step__row"
        [class.is-selected]="
          isSelected(article.supplier_certificate_product_id, article)
        "
        [class.is-processed]="isProcessed(article)"
        [class.is-partial]="
          orderService.getIsPartial(article, isProcessed(article))
        "
        (click)="articleSelected.emit(article)"
      >
        <div class="articles-step__cell articles-step__cell--code">
          {{ article.product_code }}
        </div>

        <div class="articles-step__cell articles-step__cell--name">
          {{ article.product_description }}
        </div>

        <div class="articles-step__cell articles-step__cell--qty">
          {{ orderService.batchQtyCalculation(article?.batches) }} /
          {{ article.quantity }}pz
        </div>

        <div class="articles-step__cell articles-step__cell--action">
          @if (showAction(article?.batches?.length ?? 0)) {
            <button
              type="button"
              class="articles-step__button"
              (click)="
                articleSelected.emit(article);
                triggerAction(article.supplier_certificate_product_id, $event)
              "
            >
              <span class="articles-step__button-icon">
                <i class="bx bx-plus"></i>
              </span>
              <span>{{ actionLabel }}</span>
            </button>
          } @else if (!this.completed) {
            <button
              type="button"
              class="articles-step__button"
              (click)="
                articleSelected.emit(article);
                triggerAction2(article.supplier_certificate_product_id, $event)
              "
            >
              <span class="articles-step__button-icon">
                <i class="bx bx-info-circle"></i>
              </span>
              <span>{{ hasBatchLabel }}</span>
            </button>
          }

          @if (showCompletedIcon(article)) {
            <span class="articles-step__status-icon">
              <i class="bx bx-check"></i>
            </span>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p class="articles-step__empty">Nessun articolo disponibile.</p>
}
